export enum AuthorityNotification {
  NOTIFICATION_READ = '8.1.5',
  NOTIFICATION_DELETE = '8.1.6',
  NOTIFICATION_MARK_READ = '8.1.7',
}
